export const paymentMethods = [
    {
        value: "bizum",
        label: "📱 Bizum"
    },
    {
        value: "revolut",
        label: "💳 Revolut"
    },
    {
        value: "paypal",
        label: "🅿️ PayPal"
    },
    {
        value: "cash",
        label: "💵 Cash"
    }
];